import { defineComponent as i, openBlock as t, createElementBlock as o, mergeProps as V, unref as e, renderSlot as p, createElementVNode as l, createCommentVNode as h } from "vue";
import { useScalarIcon as m } from "../hooks/useScalarIcon.js";
const u = { key: 0 }, Z = { key: 1 }, g = { key: 2 }, M = { key: 3 }, H = { key: 4 }, f = { key: 5 }, k = {
  name: "ScalarIconDeviceMobileCamera"
}, _ = /* @__PURE__ */ i({
  ...k,
  props: {
    label: {},
    weight: {}
  },
  setup(r) {
    const s = r, { bind: d, weight: n } = m(s);
    return (A, a) => (t(), o("svg", V({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, e(d)), [
      p(A.$slots, "default"),
      e(n) === "bold" ? (t(), o("g", u, a[0] || (a[0] = [
        l("path", { d: "M176,12H80A28,28,0,0,0,52,40V216a28,28,0,0,0,28,28h96a28,28,0,0,0,28-28V40A28,28,0,0,0,176,12Zm4,204a4,4,0,0,1-4,4H80a4,4,0,0,1-4-4V40a4,4,0,0,1,4-4h96a4,4,0,0,1,4,4ZM144,68a16,16,0,1,1-16-16A16,16,0,0,1,144,68Z" }, null, -1)
      ]))) : e(n) === "duotone" ? (t(), o("g", Z, a[1] || (a[1] = [
        l("path", {
          d: "M192,40V216a16,16,0,0,1-16,16H80a16,16,0,0,1-16-16V40A16,16,0,0,1,80,24h96A16,16,0,0,1,192,40Z",
          opacity: "0.2"
        }, null, -1),
        l("path", { d: "M176,16H80A24,24,0,0,0,56,40V216a24,24,0,0,0,24,24h96a24,24,0,0,0,24-24V40A24,24,0,0,0,176,16Zm8,200a8,8,0,0,1-8,8H80a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8h96a8,8,0,0,1,8,8ZM140,60a12,12,0,1,1-12-12A12,12,0,0,1,140,60Z" }, null, -1)
      ]))) : e(n) === "fill" ? (t(), o("g", g, a[2] || (a[2] = [
        l("path", { d: "M176,16H80A24,24,0,0,0,56,40V216a24,24,0,0,0,24,24h96a24,24,0,0,0,24-24V40A24,24,0,0,0,176,16ZM128,72a12,12,0,1,1,12-12A12,12,0,0,1,128,72Z" }, null, -1)
      ]))) : e(n) === "light" ? (t(), o("g", M, a[3] || (a[3] = [
        l("path", { d: "M176,18H80A22,22,0,0,0,58,40V216a22,22,0,0,0,22,22h96a22,22,0,0,0,22-22V40A22,22,0,0,0,176,18Zm10,198a10,10,0,0,1-10,10H80a10,10,0,0,1-10-10V40A10,10,0,0,1,80,30h96a10,10,0,0,1,10,10ZM138,60a10,10,0,1,1-10-10A10,10,0,0,1,138,60Z" }, null, -1)
      ]))) : e(n) === "regular" ? (t(), o("g", H, a[4] || (a[4] = [
        l("path", { d: "M176,16H80A24,24,0,0,0,56,40V216a24,24,0,0,0,24,24h96a24,24,0,0,0,24-24V40A24,24,0,0,0,176,16Zm8,200a8,8,0,0,1-8,8H80a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8h96a8,8,0,0,1,8,8ZM140,60a12,12,0,1,1-12-12A12,12,0,0,1,140,60Z" }, null, -1)
      ]))) : e(n) === "thin" ? (t(), o("g", f, a[5] || (a[5] = [
        l("path", { d: "M176,20H80A20,20,0,0,0,60,40V216a20,20,0,0,0,20,20h96a20,20,0,0,0,20-20V40A20,20,0,0,0,176,20Zm12,196a12,12,0,0,1-12,12H80a12,12,0,0,1-12-12V40A12,12,0,0,1,80,28h96a12,12,0,0,1,12,12ZM136,60a8,8,0,1,1-8-8A8,8,0,0,1,136,60Z" }, null, -1)
      ]))) : h("", !0)
    ], 16));
  }
});
export {
  _ as default
};
